import { Card, Skeleton, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import "./Table.css";

function HubSpotTable() {
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [formData, setFormData] = useState({
        staff_id,
        page: 0,
        limit: 10,
    });

    const {
        status: HubSpotStatus,
        data: HubSpotDetailsRes,
        refetch: fetchHubSpotDetails,
    } = useQuery(
        "hubSpotTicketDetails",
        async () => {
            return await HTTP("/dashboard/getHubspotTicketData", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchHubSpotDetails();
    }, []);

    useEffect(() => {
        fetchHubSpotDetails();
    }, [formData]);

    useEffect(() => {
        if (HubSpotStatus === "success") {
            const { data: hubSpotData, total } = HubSpotDetailsRes;
            setTotalRecords(total);
            setTableData(hubSpotData);
        }
    }, [HubSpotStatus, HubSpotDetailsRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const updatedFormData = { ...formData, ...others };
        setFormData(updatedFormData);
    }

    const columns = [
        {
            title: "Name",
            /* dataIndex: "project_name",
			key: "project_name", */
            render: (text, record) => (
                <span>{`${record.first_name} ${record.last_name}`} </span>
            ),
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sorter: () => {},
        },
        {
            title: "Object Id",
            dataIndex: "object_id",
            key: "object_id",
            sorter: () => {},
        },
        {
            title: "Priority",
            dataIndex: "hs_ticket_priority",
            key: "hs_ticket_priority",
            sorter: () => {},
        },
        {
            title: "Content",
            dataIndex: "content",
            key: "content",
            render: (text, record) => (
                <Tooltip placement="rightTop" title={text}>
                    <span>
                        {text.length <= 30
                            ? text
                            : `${text.substring(0, 30)}...`}
                    </span>
                </Tooltip>
            ),
            sorter: () => {},
        },
        {
            title: "Subject",
            dataIndex: "subject",
            key: "subject",
            sorter: () => {},
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            sorter: () => {},
        },
        {
            title: "Created",
            dataIndex: "createdate",
            key: "createdate",
            sorter: () => {},
        },
    ];

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <Card className="box-shadow margin-10">
                {tableData.length === 0 ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="object_id"
                        className="review-table"
                    />
                )}
            </Card>
        </Card>
    );
}
export { HubSpotTable };
